import React from "react";
import { IStoryBlokComponent } from "~src/interfaces/storyblock";
import { IMarketData } from "../../interfaces";
import styles from "./infomeeting-cards.module.scss";
import { Button } from "@ef-global/web-ui-react";
import { createSpacingClass } from "@hsey/components/src/components/utils/spacing";
import CollapsedItems from "./InfomeetingCollapsedList";
import IconArrowRight from "@ef-global/web-ui-react/lib/icons/IconArrowRight";

export interface IInfomeetingCards extends IStoryBlokComponent {
  card_spacing: any;
  card_button_content: string;
  list_text_color: any;
  list_open_text: string;
  list_close_text: string;
  infomeetings: Array<IMarketData>;
  openModal: (id: string) => void;
}

const InfomeetingCards = (props: IInfomeetingCards) => {
  const {
    card_spacing,
    card_button_content,
    infomeetings,
    list_text_color,
    list_open_text,
    list_close_text,
    openModal,
  } = props;

  const noSlice = infomeetings.length <= 3;
  const infoMeetingsDisplayed = noSlice
    ? infomeetings
    : infomeetings.splice(0, 3);
  const infoMeetingsHidden = noSlice ? [] : infomeetings;
  const spacing = createSpacingClass(card_spacing);

  return (
    <div>
      <div className="ef-row">
        {infoMeetingsDisplayed?.map((marketData, i) => (
          <div
            className={`${styles.efCardTitles} ef-col -s-12 ${
              i != 2 ? "u-mb-s" : ""
            }`}
            key={marketData.id}
          >
            <a
              className={`ef-card--content ${styles.infomeetingCardsContent}`}
              style={{ minHeight: "auto" }}
              onClick={() => openModal(marketData.id)}
            >
              <div
                className={`ef-card--content__inner  ${spacing ? spacing : ""}`}
                style={{ width: "100%" }}
              >
                <div className="ef-card--content__content">
                  <div className="ef-row">
                    <div className="ef-col">
                      <p className="u-mb-xs">{marketData.date}</p>
                      <h2
                        className={`ef-h6 ef-card--content__title u-mb-0`}
                        style={{
                          flex: 0,
                        }}
                      >
                        {marketData.title}
                      </h2>
                    </div>
                    <div className={`${styles.actionContent}`}>
                      <Button secondary className="u-show-m-up">
                        {card_button_content}
                      </Button>
                      <Button className="u-show-m-down">
                        <IconArrowRight />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
      <div className="ef-row">
        {infoMeetingsHidden.length > 0 && (
          <CollapsedItems
            buttonTextColor={list_text_color?.color ?? null}
            buttonTextShow={list_open_text}
            buttonTextHide={list_close_text}
          >
            {infoMeetingsHidden?.map((marketData) => (
              <div
                className={`u-mb-s ${styles.efCardTitles}`}
                key={marketData.id}
              >
                <a
                  className={`ef-card--content ${styles.infomeetingCardsContent}`}
                  style={{ minHeight: "auto" }}
                  onClick={() => openModal(marketData.id)}
                >
                  <div
                    className="ef-card--content__inner"
                    style={{ width: "100%" }}
                  >
                    <div className="ef-card--content__content">
                      <div className="ef-row">
                        <div className="ef-col">
                          <p className="u-mb-xs">{marketData.date}</p>
                          <h2
                            className={`ef-h6 ef-card--content__title u-mb-0`}
                            style={{
                              flex: 0,
                            }}
                          >
                            {marketData.title}
                          </h2>
                        </div>
                        <div className={`button-box ${styles.actionContent}`}>
                          <Button secondary className="u-show-m-up">
                            {card_button_content}
                          </Button>
                          <Button secondary className="u-show-m-down">
                            <IconArrowRight />
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </CollapsedItems>
        )}
      </div>
    </div>
  );
};

export default InfomeetingCards;
